import {
  Box, Tab, Tabs, withStyles,
} from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import config from '@/configs/config';
import TabPanel from '../../preorder/components/TabPanel';
import ProgressBackdrop from '../../preorder/components/ProgressBackdrop';
import List from './List';

const TAB_MAP = {
  RECENT_PURCHASED_ITEMS: 'RECENT_PURCHASED_ITEMS',
  MY_SUBSCRIBED_ITEMS: 'MY_SUBSCRIBED_ITEMS',
};

const StyledTab = withStyles((theme) => ({
  root: {
    backgroundColor: 'rgb(216,216,216)',
    borderRadius: 6,
    color: 'rgb(68,68,68)',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    fontWeight: 'bold',
    height: 29,
    minHeight: 'auto',
    padding: 0,
    '&+&': {
      marginLeft: theme.spacing(1),
    },
  },
  selected: {
    backgroundColor: 'black',
    color: 'white',
  },
}))(Tab);

const StyledTabs = withStyles({
  root: {
    minHeight: 'auto',
    width: '100%',
  },
  scroller: {
    width: '100%',
  },
  flexContainer: {
    justifyContent: 'center',
  },
  indicator: {
    display: 'none',
  },
})(Tabs);

export default ({
  isLoading,
  onSubscribeButtonClick = () => {},
  onSubscribeItemClick = () => {},
  onUnsubscribeButtonClick = () => {},
  onUnsubscribeItemClick = () => {},
  recentPurchasedItems = [],
  selectedItemIdsToSubscribe = [],
  selectedItemIdsToUnsubscribe = [],
  subscribedItems,
}) => {
  const [activateTab, setActivateTab] = useState(TAB_MAP.RECENT_PURCHASED_ITEMS);

  const onActivateTabChange = useCallback((_event, value) => {
    setActivateTab(value);
  }, [setActivateTab]);

  return (
    <Box
      width={1}
      display="flex"
      flexDirection="column"
      alignItems="stretch"
      fontSize={16}
      px={1.5}
    >
      <ProgressBackdrop isShow={isLoading} />
      <StyledTabs value={activateTab} onChange={onActivateTabChange}>
        <StyledTab label="近期消費品項" value={TAB_MAP.RECENT_PURCHASED_ITEMS} />
        <StyledTab label="已訂閱的品項" value={TAB_MAP.MY_SUBSCRIBED_ITEMS} />
      </StyledTabs>
      <Box>
        <TabPanel id={TAB_MAP.RECENT_PURCHASED_ITEMS} activateId={activateTab}>
          <Box textAlign="center" mt={4}>
            <Box>
              嗨！您好！感謝您在
              {config.BrandNameTW}
              購餐
            </Box>
            <Box>若有您特別喜歡的餐點建議加入追蹤</Box>
            <Box>下次再上架會優先通知您喔！</Box>
          </Box>
          <Box mt={2.25} justifySelf="start">
            <List
              buttonText="訂閱"
              buttonColor="rgb(232,187,49)"
              emptyText="您近期沒有購買任何品項。"
              items={recentPurchasedItems}
              onButtonClick={onSubscribeButtonClick}
              onItemClick={onSubscribeItemClick}
              selectedItemsId={selectedItemIdsToSubscribe}
            />
          </Box>
        </TabPanel>
        <TabPanel id={TAB_MAP.MY_SUBSCRIBED_ITEMS} activateId={activateTab}>
          <Box mt={3}>
            <List
              buttonText="取消訂閱"
              buttonColor="rgb(206,0,0)"
              emptyText="您尚未訂閱任何的品項。"
              items={subscribedItems}
              onButtonClick={onUnsubscribeButtonClick}
              onItemClick={onUnsubscribeItemClick}
              selectedItemsId={selectedItemIdsToUnsubscribe}
            />
            <Box fontSize={16} color="rgb(104,104,104)" mt={1.75} textAlign="center">移出收藏清單的餐點將不會再收到上架通知</Box>
          </Box>
        </TabPanel>
      </Box>
    </Box>
  );
};
